import { Component, ChangeDetectionStrategy, Input, ContentChild } from '@angular/core';
import { CsLabelComponent } from '../cs-label/cs-label';
import { TranslatedString } from 'models/translated-string';

@Component({
  selector: 'cs-form-field',
  templateUrl: 'cs-form-field.html',
  host: { 'class': 'form-field' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsFormField {
  @Input() label?: TranslatedString;
  @ContentChild(CsLabelComponent) labelContent?: CsLabelComponent;

  get shouldShowInputLabel(): boolean {
    return !!this.label && !this.labelContent;
  }
}
